import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { AIHistoryStatsCard, ValueWithChange } from './index';
import { CustomModalWithoutButton } from '@/components';
import AIHistoryChartModal from './AIHistoryChartModal';
import { AIHistoryStatsSectionProps, MetricItem } from '../type';
import { LeftArrowIcon, RightArrowIcon } from '@/assets/icons/icons';

const AIHistoryStatsSection: React.FC<AIHistoryStatsSectionProps> = ({
  kpiData,
}) => {
  const [openBufferModal, setOpenBufferModal] = useState<boolean>(false);
  const [selectedCardData, setSelectedCardData] = useState<MetricItem>({});
  const [chartData, setCharData] = useState({
    categories: [],
    data: [],
  });

  const handleCardClick = (item: MetricItem) => {
    if (item) {
      setSelectedCardData(item);
      setOpenBufferModal(true);
      setCharData({
        categories: item?.chart?.categories,
        data: item?.chart?.data,
      });
    }
  };

  const [currentIndex, setCurrentIndex] = useState<number>(0);

  useEffect(() => {
    const index = kpiData.findIndex(
      (item) => item.type === selectedCardData?.type
    );
    if (index >= 0) setCurrentIndex(index);
  }, [selectedCardData?.type, kpiData]);

  const goPrev = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      const item = kpiData[newIndex];

      setCurrentIndex(newIndex);
      setSelectedCardData(item);
      setCharData({
        categories: item?.chart?.categories || [],
        data: item?.chart?.data || [],
      });
    }
  };

  const goNext = () => {
    if (currentIndex < kpiData.length - 1) {
      const newIndex = currentIndex + 1;
      const item = kpiData[newIndex];

      setCurrentIndex(newIndex);
      setSelectedCardData(item);
      setCharData({
        categories: item?.chart?.categories || [],
        data: item?.chart?.data || [],
      });
    }
  };
  return (
    <>
      <Row gutter={[12, 12]}>
        {kpiData.map((item) => (
          <Col
            onClick={() => handleCardClick(item)}
            key={item.title}
            xs={24}
            sm={24}
            md={24}
            lg={12}
            xl={6}
            xxl={6}
            style={{ cursor: 'pointer' }}
          >
            <AIHistoryStatsCard {...item} />
          </Col>
        ))}
      </Row>

      <CustomModalWithoutButton
        modalOpen={openBufferModal}
        setModalOpen={setOpenBufferModal}
        modalTitle={selectedCardData?.title || ''}
        fontSize={'14px'}
        lineHeight='20px'
        modalText=''
        modalTextFontSize={'12px'}
        modalSize={500}
        modalBorderRadius={'16px'}
      >
        <div className='ai-history-charts-arrows'>
          <span
            className={currentIndex === 0 ? 'disabled-row' : ''}
            onClick={currentIndex === 0 ? undefined : goPrev}
            style={{
              display: 'inline-flex',
              cursor: currentIndex === 0 ? 'not-allowed' : 'pointer',
            }}
          >
            <LeftArrowIcon />
          </span>
          <span
            className={
              currentIndex === kpiData.length - 1 ? 'disabled-row' : ''
            }
            onClick={currentIndex === kpiData.length - 1 ? undefined : goNext}
            style={{
              display: 'inline-flex',
              cursor:
                currentIndex === kpiData.length - 1 ? 'not-allowed' : 'pointer',
            }}
          >
            <RightArrowIcon />
          </span>
        </div>
        <ValueWithChange
          value={selectedCardData?.value}
          unit={selectedCardData?.unit}
          change={selectedCardData?.change}
          is_negative={selectedCardData?.is_negative}
          showChangeText={true}
        />

        <AIHistoryChartModal
          chartData={chartData}
          selectedCardData={selectedCardData}
        />
      </CustomModalWithoutButton>
    </>
  );
};

export default AIHistoryStatsSection;
